import React, {Component} from 'react';
import {Link} from 'react-router-dom'

class Breadcrumb extends Component {
    render (){
        const {title, parents, localRoot} = this.props;
        return (
            <div className="breadcrumb-section">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="page-title">
                                <nav aria-label="breadcrumb" className="theme-breadcrumb">
                                    <ol className="breadcrumb">
                                        {localRoot 
                                        ?   <li className="breadcrumb-item"><Link to={localRoot.url}>{localRoot.name}</Link></li>
                                        :   <li className="breadcrumb-item"><Link to={`${process.env.PUBLIC_URL}`}>Home</Link></li>
                                        }
                                        {parents && parents.map((parent, index) => 
                                            <li className="breadcrumb-item" key={index} ><Link to={parent.url}>{parent.name}</Link></li>
                                        )
                                        }
                                        <li className="breadcrumb-item active" >{title}</li>
                                    </ol>
                                </nav>                            
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        )
    }
}

export default Breadcrumb;